const evo_endpoint = document.location.hostname.endsWith('legrandcontinent.eu')
  ? 'ev.legrandcontinent.eu'
  : 'lgc.uat.evolok.net'

// Costanti e configurazione
const EVOLOK_CONFIG = {
  API_BASE_URL: `https://${evo_endpoint}/ic/api`,
  WP_API_ENDPOINT: 'wp-json/lgc/v1/articles',
  CSS_CLASSES: {
    LOADER: [
      'articles-loader',
      'text-center',
      'flex',
      'justify-center',
      'items-center',
      'loading',
    ],
    DYNAMIC_CONTENT: ['dynamic-content'],
    POST_GRID: [
      'mt-6',
      'md:mt-12',
      'grid',
      'md:grid-cols-2',
      'lg:grid-cols-3',
      'gap-x-6',
      'gapy-6',
      'md:gap-y-12',
    ],
    POST_CONTAINER: ['block', 'mb-2'],
    POST_CONTENT: [''],
    POST_IMAGE: ['block', 'mx-auto', 'picture-100', 'aspect-square'],
    TITLE_LINK: [
      'block',
      'font-display',
      'text-md',
      '!no-underline',
      'hover:!no-underline',
      'mt-2',
    ],
    READ_MORE: [
      'font-sans',
      'text-3xs',
      'no-underline',
      '!text-red',
      '!hover:text-red-h',
      'transition-c',
      '!no-underline',
      'hover:!no-underline',
    ],
    TITLE: [
      '!mb-1',
      '!text-xs',
      '!font-display',
      '!font-semibold',
      'uppercase',
      'evolok-title-decoration',
    ],
    IMAGE: ['block', 'w-18', 'mx-auto', 'picture-100'],
  },
  LABELS: {
    READ_MORE: `${lgc_global.labels.read_more} →`,
    SAVED_TITLE: `${lgc_global.labels.saved_articles_title} `,
    READ_TITLE: `${lgc_global.labels.read_articles_title} `,
  },
}

import MicroModal from 'micromodal'
import Pdf from './Pdf'
// chiamate API
class EvolokApiService {
  constructor(user) {
    this.user = user
    this.baseUrl = EVOLOK_CONFIG.API_BASE_URL
    this.blogId = window.lgc_global.blogId
  }

  _getAuthHeader(service) {
    return `Evolok evolok.api.service=${service} evolok.api.sessionId=${this.user.sessionId}`
  }

  savePost(postId) {
    const url = `${this.baseUrl}/userProfileAttribute/${this.user.guid}/articles_saved/properties`
    const payload = {
      update: [
        {
          properties: [
            { name: 'blog_id', value: this.blogId },
            { name: 'post_id', value: postId },
            {
              name: 'when',
              value: Math.floor(
                new Date(Date.now()).getTime() / 1000
              ).toString(),
            },
          ],
        },
      ],
      clear: false,
    }

    return fetch(url, {
      method: 'POST',
      headers: {
        Authorization: this._getAuthHeader('articles'),
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(payload),
    }).then((response) => {
      if (!response.ok) {
        throw new Error(`Save post failed: ${response.status}`)
      }
      return response.json()
    })
  }
  removePost(postId, currentPayload) {
    const url = `${this.baseUrl}/userProfileAttribute/${this.user.guid}/articles_saved/properties`
    const updatedPayload = currentPayload.filter((el) => {
      const props = this._getPropertiesObject(el)
      return props.post_id !== postId && props.blog_id === this.blogId
    })

    const payload = {
      update: updatedPayload,
      clear: true,
    }

    return fetch(url, {
      method: 'POST',
      headers: {
        Authorization: this._getAuthHeader('articles'),
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(payload),
    }).then((response) => {
      if (!response.ok) {
        throw new Error(`Save post failed: ${response.status}`)
      }
      return response.json()
    })
  }

  getSavedArticles() {
    const url = `${this.baseUrl}/userProfile/${this.user.guid}?includeCollectionAttributes=true`

    return fetch(url, {
      method: 'GET',
      headers: {
        Authorization: this._getAuthHeader('articles'),
        'Content-Type': 'application/xml',
        Accept: 'application/json',
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Get saved articles failed: ${response.status}`)
        }

        return response.json()
      })
      .then((results) => {
        return this._processArticles(results, 'articles_saved')
      })
  }

  getCurrentPayload() {
    const url = `${this.baseUrl}/userProfile/${this.user.guid}?includeCollectionAttributes=true`

    return fetch(url, {
      method: 'GET',
      headers: {
        Authorization: this._getAuthHeader('articles'),
        'Content-Type': 'application/xml',
        Accept: 'application/json',
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Get saved articles failed: ${response.status}`)
        }

        return response.json()
      })
      .then((results) => {
        return this._processArticles(results, 'articles_saved', false)
      })
  }

  getUserInfo() {
    const url = `${this.baseUrl}/userProfile/${this.user.guid}?includeMultiValuedAttributes=true`

    // Chiamata per account info
    const accountInfoPromise = fetch(url, {
      method: 'GET',
      headers: {
        Authorization: this._getAuthHeader('account'),
        'Content-Type': 'application/xml',
        Accept: 'application/json',
      },
    }).then((response) => {
      if (!response.ok) {
        throw new Error(`Get account info failed: ${response.status}`)
      }
      return response.json()
    })

    // Chiamata per subscription info
    const subscriptionInfoPromise = fetch(url, {
      method: 'GET',
      headers: {
        Authorization: this._getAuthHeader('pm_purchase_sync'),
        'Content-Type': 'application/xml',
        Accept: 'application/json',
      },
    }).then((response) => {
      if (!response.ok) {
        throw new Error(`Get subscription info failed: ${response.status}`)
      }
      return response.json()
    })

    return Promise.all([accountInfoPromise, subscriptionInfoPromise]).then(
      ([accountInfo, subscriptionInfo]) => {
        return {
          accountInfo: accountInfo.userProfile?.attributes?.reduce(
            (acc, curr) => {
              acc[curr.name] = curr.value
              return acc
            },
            {}
          ),
          subscriptionInfo: subscriptionInfo.userProfile?.attributes?.reduce(
            (acc, curr) => {
              acc[curr.name] = curr.value
              return acc
            },
            {}
          ),
          segments: this.user.segments,
        }
      }
    )
  }

  readPost(postId, postTemplate) {
    const url = `${this.baseUrl}/userProfileAttribute/${this.user.guid}/articles_read/properties`
    const payload = {
      update: [
        {
          properties: [
            { name: 'blog_id', value: this.blogId },
            { name: 'post_id', value: postId },
            { name: 'template', value: postTemplate },
            {
              name: 'when',
              value: Math.floor(
                new Date(Date.now()).getTime() / 1000
              ).toString(),
            },
          ],
        },
      ],
      clear: false,
    }

    return fetch(url, {
      method: 'POST',
      headers: {
        Authorization: this._getAuthHeader('articles'),
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(payload),
    }).then((response) => {
      if (!response.ok) {
        throw new Error(`Save post failed: ${response.status}`)
      }
      return response.json()
    })
  }

  getReadArticles() {
    const url = `${this.baseUrl}/userProfile/${this.user.guid}?includeCollectionAttributes=true`

    return fetch(url, {
      method: 'GET',
      headers: {
        Authorization: this._getAuthHeader('articles'),
        'Content-Type': 'application/xml',
        Accept: 'application/json',
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Get read articles failed: ${response.status}`)
        }
        return response.json()
      })
      .then((results) => {
        return this._processArticles(results, 'articles_read')
      })
  }

  getPostsData(groupedArticles) {
    if (!groupedArticles?.length) {
      return Promise.resolve([])
    }

    return fetch(
      `${window.lgc_global.blogPath}${EVOLOK_CONFIG.WP_API_ENDPOINT}`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(groupedArticles),
      }
    ).then((response) => {
      if (!response.ok) {
        throw new Error(`Get posts data failed: ${response.status}`)
      }

      return response.json()
    })
  }

  _processArticles(results, type, formatted = true) {
    const attributePropertyCollections =
      results.userProfile.attributePropertyCollections
    const articlesArray = attributePropertyCollections.filter(
      (attr) => attr.attributeCollectionsName === type
    )?.[0]?.elements

    if (!articlesArray) return []

    // Raggruppa gli articoli per blog_id
    const groupedMap = {}

    articlesArray.forEach((entry) => {
      const obj = Object.fromEntries(entry.items.map((i) => [i.name, i.value]))

      const blogId = obj.blog_id
      const postId = parseInt(obj.post_id, 10)

      if (!groupedMap[blogId]) {
        groupedMap[blogId] = []
      }

      groupedMap[blogId].push(postId)
    })

    if (!formatted) {
      return articlesArray
    }

    return Object.entries(groupedMap).map(([blogId, postIds]) => ({
      blog_id: parseInt(blogId, 10),
      post_ids: postIds,
    }))
  }
  _getPropertiesObject(el) {
    const propsArray = el.items || el.properties
    if (!propsArray) {
      console.warn('Nessun items o properties trovato in', el)
      return {}
    }
    return propsArray.reduce((acc, prop) => {
      acc[prop.name] = prop.value
      return acc
    }, {})
  }
}

// rendering
class EvolokUIRenderer {
  constructor(savedArticlesSection, readArticlesSection) {
    this.savedArticlesSection = savedArticlesSection
    this.readArticlesSection = readArticlesSection
    this.loader = null
    this.postsWrapper = null
  }

  showLoader(section) {
    this.clearContent(section)

    if (!this.loader) {
      this.loader = this._createLoader()
    }
    section.appendChild(this.loader)
  }

  hideLoader() {
    if (this.loader && this.loader.parentNode) {
      setTimeout(() => {
        this.loader.remove()
        this.loader = null
        if (this.postsWrapper) {
          this.postsWrapper.classList.remove('hidden')
          this.postsWrapper.classList.add('block')
        }
      }, 100)
    }
  }

  clearContent(section) {
    const existingContent = section.querySelectorAll('.dynamic-content')
    existingContent.forEach((element) => element.remove())
  }

  renderPosts(data, section, sectionTitle) {
    if (!section || !data?.length) {
      this.renderNoPostsMessage(section)
      return
    }

    const wrapper = document.createDocumentFragment()

    data.forEach((group) => {
      const { posts } = group

      const postsContainer = document.createElement('div')
      postsContainer.classList.add(...EVOLOK_CONFIG.CSS_CLASSES.DYNAMIC_CONTENT)

      const postsGrid = document.createElement('div')
      postsGrid.classList.add(...EVOLOK_CONFIG.CSS_CLASSES.POST_GRID)
      postsContainer.appendChild(postsGrid)

      posts?.forEach((post) => {
        const postElement = this._createPostElement(post)
        postsGrid.appendChild(postElement)
      })

      this.postsWrapper = postsContainer
      wrapper.appendChild(postsContainer)
    })

    section.appendChild(wrapper)
  }

  renderNoPostsMessage(section) {
    const div = document.createElement('div')
    div.innerText = window.lgc_global?.labels?.no_posts || 'No posts found'
    div.classList.add('no-posts-message')
    section.appendChild(div)
  }

  _createLoader() {
    const loaderWrapper = document.createElement('div')
    loaderWrapper.classList.add(...EVOLOK_CONFIG.CSS_CLASSES.LOADER)

    const loader = document.createElement('div')
    loader.id = 'ev-outer-loader'

    const spinner = document.createElement('div')
    loader.appendChild(spinner)
    loaderWrapper.appendChild(loader)

    return loaderWrapper
  }

  _createPostElement(post) {
    const container = document.createElement('div')
    container.classList.add(...EVOLOK_CONFIG.CSS_CLASSES.POST_CONTAINER)

    // Sanitizza i dati
    const safeTitle = this._escapeHtml(post.title || '')
    const safeLink = post.link || '#'
    const safeThumbnail = post.thumbnail_url || ''

    // Usa template per la struttura HTML
    const template = `
    <div class="flex gap-6 md:block">
      ${
        safeThumbnail
          ? `
          <a href="${safeLink}" class="block w-1/3 aspect-[2/3] h-full md:w-full md:mb-2 s md:aspect-square ">
            <img src="${safeThumbnail}" alt="${safeTitle}" class="block w-full h-full object-cover mx-auto picture-100 ">
          </a>
      `
          : ''
      }
      <div>
      ${
        post.template_slug && post.template_name
          ? `<a href="${post.template_slug}" class="post-template  transition-c">
            ${post.template_name}
          </a>`
          : ''
      }
            ${
              post.terms
                ? post.terms
                    .map(
                      (el) =>
                        `<a href="${el.link}" class="post-term dot-before transition-c">
            ${el.name}
          </a>`
                    )
                    .join('')
                : ''
            }
        <a href="${safeLink}" class="block title-link text-base mt-2 hover:!no-underline text-black">
          ${safeTitle}
        </a>
        </div>
        </div>
    `

    container.innerHTML = template
    return container
  }

  // Funzione di sanitizzazione per prevenire XSS
  _escapeHtml(text) {
    const div = document.createElement('div')
    div.textContent = text
    return div.innerHTML
  }
}

// azioni ed eventi
class EvolokActionHandler {
  constructor(user, savedArticlesSection) {
    this.user = user
    this.blogId = window.lgc_global.blogId
    this.isSubscribed = user.userType === 'subscribed'
    this.canSave = user.canSave
    this.canDownload = user.canDownload
    this.loggedOut = user.loggedOut
    this.apiService = new EvolokApiService(user)
    this.uiRenderer = new EvolokUIRenderer(savedArticlesSection)
    this.isLoading = false
    this.eventListeners = new Map() // traccia i listener per il cleanup
    this.currentPayload
    this.isAlreadySaved
  }

  init() {
    console.log('🧐 user', this.user)
    const userMenus = document.querySelectorAll('.user-menu')

    userMenus?.forEach((menu) => {
      this.loggedOut
        ? menu.classList.remove('user-is-logged-in')
        : menu.classList.add('user-is-logged-in')
      menu.classList.remove('opacity-0')
    })
    const dashboard = document.querySelector('.page-template-page-dashboard')
    const isArticle = document.body.classList.contains('post-template')
    const loadPayload = !!dashboard || isArticle

    if (this.canSave && loadPayload) {
      this.getCurrentPayload()
        .then((payload) => {
          this.currentPayload = payload
        })
        .catch((err) => {
          console.log('ERR', err)
        })
        .finally(() => this.handleActionBar())

      if (document.body.classList.contains('single-post')) {
        const article = document.querySelector('article')
        if (article) {
          this.readPost(article)
        }
      }
    }

    if (!this.canSave || !this.canDownload) {
      this.handleActionBar()
    }
  }

  destroy() {
    // Cleanup degli event listeners
    this.eventListeners.forEach((cleanup, element) => {
      cleanup()
    })
    this.eventListeners.clear()
  }

  handleActionBar() {
    const actionBtns = document.querySelectorAll('.userAction')

    actionBtns?.forEach((btn) => {
      const postId = btn.dataset.postid
      if (btn.classList.contains('saveAction')) {
        this._handleSaveButton(btn)
        this.isAlreadySaved = this._alreadySavedChecker(postId)
        if (this._alreadySavedChecker(postId)) {
          btn.classList.add('done')
          btn.classList.remove('dsdsa')
        } else {
          btn.classList.remove('done')
          btn.classList.add('dsdsa')
        }
      }

      if (btn.classList.contains('generatePdfAction')) {
        this._handlePdfButton(btn)
      }
    })
  }

  getCurrentPayload() {
    return this.apiService
      .getCurrentPayload()
      .then((groupedArticles) => {
        const transformed = groupedArticles.map((el) => {
          return {
            properties: el.items,
          }
        })

        return transformed
      })
      .catch((error) => {
        console.error('Error loading saved articles:', error)
        throw error
      })
  }

  getUserInfo() {
    return this.apiService
      .getUserInfo()
      .then((res) => res)
      .catch((error) => {
        console.error('Error loading saved articles:', error)
        throw error
      })
  }

  getSavedArticles() {
    // if (this.isLoading) return Promise.resolve()

    // this.isLoading = true
    // this.uiRenderer.showLoader(this.savedArticlesSection)

    return this.apiService
      .getSavedArticles()
      .then((groupedArticles) => {
        return this.apiService.getPostsData(groupedArticles)
      })
      .then((postsData) => {
        // this.uiRenderer.renderPosts(
        //   postsData,
        //   this.savedArticlesSection,
        //   EVOLOK_CONFIG.LABELS.SAVED_TITLE
        // )
        // Analytics
        this._trackEvent('articles_loaded', { count: postsData.length })
        return postsData
      })
      .catch((error) => {
        console.error('Error loading saved articles:', error)
        // this.uiRenderer.renderNoPostsMessage(this.savedArticlesSection)
        throw error
      })
    // .finally(() => {
    //   this.isLoading = false
    //   this.uiRenderer.hideLoader()
    // })
  }

  renderArticles(articles, type = 'saved') {
    const section =
      type === 'saved'
        ? this.uiRenderer.savedArticlesSection
        : this.uiRenderer.readArticlesSection

    if (!section) {
      console.warn('Section not found for', type)
      return
    }

    return this.uiRenderer.renderPosts(articles, section)
  }
  getDashboardData() {
    let dashboard_data_section = document.getElementById(
      'dashboard-data-section'
    )

    if (dashboard_data_section) {
      document.getElementById('dashboard').innerHTML =
        dashboard_data_section.innerHTML
    } else {
      document.getElementById('dashboard').innerHTML = '<p>Dashboard</p>'
    }
  }

  savePost(event) {
    event.preventDefault()

    const postId = event.currentTarget.dataset.postid
    if (!postId || !this.currentPayload) return Promise.resolve()
    this._togglePending(event.currentTarget, !this.isAlreadySaved)

    if (this.isAlreadySaved) {
      return this.apiService
        .removePost(postId, this.currentPayload)
        .then((result) => {
          this._toggleStatus(event.currentTarget)
          // this._trackEvent('post_saved', { postId })
          return result
        })
        .catch((error) => {
          console.error('Error saving post:', error)
          throw error
        })
        .finally(() => {
          this._togglePending(event.currentTarget, false)
        })
    }

    return this.apiService
      .savePost(postId)
      .then((result) => {
        this._toggleStatus(event.currentTarget)
        this._trackEvent('post_saved', { postId })
        return result
      })
      .catch((error) => {
        console.error('Error saving post:', error)
        throw error
      })
      .finally(() => {
        this._togglePending(event.currentTarget, false)
      })
  }

  getReadArticles() {
    // if (this.isLoading) return Promise.resolve()

    // this.isLoading = true
    // this.uiRenderer.showLoader(this.readArticlesSection)

    return this.apiService
      .getReadArticles()
      .then((groupedArticles) => {
        return this.apiService.getPostsData(groupedArticles)
      })
      .then((postsData) => {
        // this.uiRenderer.renderPosts(
        //   postsData,
        //   this.readArticlesSection,
        //   EVOLOK_CONFIG.LABELS.READ_TITLE
        // )
        // Analytics

        return postsData
      })
      .catch((error) => {
        console.error('Error loading saved articles:', error)
        // this.uiRenderer.renderNoPostsMessage(this.readArticlesSection)
        throw error
      })
    // .finally(() => {
    //   this.isLoading = false
    //   this.uiRenderer.hideLoader()
    // })
  }
  readPost(article) {
    const postId = article.dataset.id
    const postTemplate = article.dataset.format

    if (!postId) return Promise.resolve()

    return this.apiService
      .readPost(postId, postTemplate)
      .then((result) => {
        return result
      })
      .catch((error) => {
        console.error('Error saving post:', error)
        throw error
      })
  }

  _alreadySavedChecker(postId) {
    if (!postId || !this.currentPayload) return
    const isAlreadySaved = this.currentPayload.find((el) => {
      const props = this._getPropertiesObject(el)
      return props.post_id === postId && props.blog_id === this.blogId
    })

    return isAlreadySaved
  }
  _handleSaveButton(btn) {
    if (this.canSave) {
      btn.classList.remove('savePostDisabled')
      const handler = (e) => this.savePost(e)
      btn.addEventListener('click', handler)
      this.eventListeners.set(btn, () =>
        btn.removeEventListener('click', handler)
      )
    } else {
      btn.classList.add('savePostDisabled')
      btn.addEventListener('click', (e) => {
        e.preventDefault()

        const bannerManager = new EvolokBannerManager({
          bannersData: window.banners_data,
          altBanner: window.alt_banner,
        })
        bannerManager.showBanner(this.user.userType, 'save')
      })
    }

    this._trackEvent('save_favorite', { subscribed: this.isSubscribed })
  }

  _handlePdfButton(btn) {
    if (this.canDownload) {
      btn.classList.remove('generatePdfDisabled')
      const generatePdf = new Pdf(this.user, btn)
      generatePdf.init()
    } else {
      btn.classList.add('generatePdfDisabled')
      btn.addEventListener('click', (e) => {
        e.preventDefault()

        const bannerManager = new EvolokBannerManager({
          bannersData: window.banners_data,
          altBanner: window.alt_banner,
        })
        bannerManager.showBanner(this.user.userType, 'pdf')
      })
    }
    this._trackEvent('DownloadPDF', { subscribed: this.canDownload })
  }

  _toggleStatus(element) {
    const saveElements = document.querySelectorAll('.saveAction')
    saveElements.forEach((el) => {
      el.classList.toggle('done')
      el.classList.toggle('dsdsa')
    })
  }

  _togglePending(add = true) {
    const saveElements = document.querySelectorAll('.saveAction')
    saveElements.forEach((el) => {
      if (add) {
        el.classList.add('pending')
      } else {
        el.classList.remove('pending')
      }
    })
  }

  _trackEvent(eventName, data = {}) {
    if (window.dataLayer) {
      window.dataLayer.push({
        event: eventName,
        ...data,
      })
    }
  }

  _getPropertiesObject(el) {
    const propsArray = el.items || el.properties
    if (!propsArray) {
      console.warn('Nessun items o properties trovato in', el)
      return {}
    }
    return propsArray.reduce((acc, prop) => {
      acc[prop.name] = prop.value
      return acc
    }, {})
  }
}

// Gestione dei banner
class EvolokBannerManager {
  constructor({ altBanner = false, electionsBanner = false }) {
    this.bannersData = JSON.parse(lgc_global.banners_data)
    this.altBanner = altBanner
    this.electionsBanner = electionsBanner
  }

  _getBannerData(user, type) {
    if (!this.bannersData) return null
    return this.bannersData.find(
      (item) => item.type === type && item.user === user
    )
  }

  showBanner(userType, bannerType) {
    if (!userType || !bannerType) return

    let bannerTypeContent = this.altBanner ? `${bannerType}_alt` : bannerType
    if (this.electionsBanner) {
      bannerTypeContent = `${bannerType}_elections`
    }

    const data = this._getBannerData(userType, bannerTypeContent)
    if (!data) return

    const banner = this._markupDisposableBanner(data)

    this._attachBanner(banner, bannerType)
  }

  _attachBanner(banner, bannerType) {
    // Rimuove eventuali banner esistenti
    document.querySelectorAll('.disposableBanner').forEach((el) => el.remove())

    switch (bannerType) {
      case 'paywall':
        document.body.classList.add('pw')
        document.body.insertAdjacentHTML('beforeend', banner)
        document.addEventListener('scroll', showPaywallOnScroll)
        break

      case 'softwall':
      case 'save':
      case 'pdf':
        document.body.insertAdjacentHTML('beforeend', banner)
        document
          .getElementById('close-banner-btn')
          ?.addEventListener('click', () => {
            document.body.classList.remove('db-show')
            window.dataLayer?.push({
              event: 'ClickClosePayWall',
              paywallType: bannerType,
            })
          })

        document
          .querySelector('.pw-content .redirect_btn')
          ?.addEventListener('click', () => {
            window.dataLayer?.push({
              event: 'ClickSubscribe',
              origin: bannerType,
            })
          })

        window.setTimeout(
          () => document.body.classList.add('db-show'),
          bannerType === 'softwall' ? 1500 : 10
        )

        window.dataLayer?.push({
          event: 'PaywallViews',
          paywallType: bannerType,
        })
        break
    }

    // Inizializza MicroModal e login
    MicroModal.init({ disableFocus: true })
    document.body.addEventListener('click', (event) => {
      if (event.target.matches('.banner-login-btn')) {
        event.preventDefault()
        MicroModal.show('login-modal')
      }
    })
  }

  _markupDisposableBanner(data) {
    const markup = `<div class="disposableBanner pointer-events-none  fixed top-0 left-0 bottom-0 right-0 z-100">
        <div class="pw-backdrop bg-gradient-to-b from-transparent to-black opacity-0 transition-opacity fixed top-0 left-0 w-full h-full"></div>
        <div class="pw-content pointer-events-auto transition-all translate-y-full opacity-0 py-5 fixed bottom-0 left-0 w-full bg-grey-lightest text-${
          data.alignment
        }" ${
      data.background_color
        ? 'style="background-color:' + data.background_color + ';"'
        : ''
    }>
          <div class="px-4 lg:px-0 mx-auto max-w-[985px] relative ${
            data.white_text ? 'text-white' : ''
          }">
            <div class="relative lg:max-w-[685px]">
              <div class="relative z-1">
                <div class="font-sans tracking-wide uppercase font-bold text-sm mr-8 ${
                  data.white_text ? 'text-white' : 'text-red'
                }">${data.label}</div>
                <h3 class="font-display font-semibold text-2xl md:text-3xl mt-4">${
                  data.title
                }</h3>
                <div class="font-sans text-sm md:text-l pr-24 md:pr-40 lg:pr-8 mt-2 mb-4">${
                  data.text
                }</div>
                  ${
                    data.button
                      ? `<a href="${data.button.url}" target="${
                          data.button.target
                        }" class="redirect_btn  ${
                          data.white_text
                            ? 'btn-outline btn-outline-white'
                            : 'btn-red'
                        } md:min-w-[345px]">${data.button.title}</a>`
                      : ''
                  }
                  <br/><span class='inline-block font-sans mt-4'>
                  ${data.login_txt_before ? data.login_txt_before : ''}
                  ${
                    data.login_link_txt
                      ? `
                  <a class='banner-login-btn text-red' href='#'>
                    ${data.login_link_txt}
                  </a> `
                      : ''
                  }
                  ${data.login_txt_after ? data.login_txt_after : ''}
                </span>
              </div>
              ${
                data.image
                  ? `<img src="${data.image.url}" class="absolute right-0 lg:right-auto lg:left-full bottom-20 lg:bottom-1/2 translate-y-1/2 w-[90px] h-[90px] md:w-[170px] md:h-[170px] object-contain mix-blend-multiply"/>`
                  : ''
              }              
            </div>
            <div id="close-banner-btn" class="absolute p-4 right-2 -top-4 cursor-pointer z-10 ${
              data.white_text ? 'text-black' : 'text-red'
            }">
              <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 14" width="15" height="14">
                  <path d="M 1.3710938 0 L 0 1.4570312 L 6.296875 7.3789062 L 0 13.300781 L 1.3710938 14.757812 L 7.7578125 8.7519531 L 14.142578 14.757812 L 15.513672 13.300781 L 9.2167969 7.3789062 L 15.513672 1.4570312 L 14.142578 0 L 7.7578125 6.0058594 L 1.3710938 0 z " />
              </svg>
            </div>
          </div>
        </div>
        </div>`
    return markup
  }
}

// Classe principale
export default class EvolokActions extends EvolokActionHandler {
  constructor(user, savedArticlesSection = null, readArticlesSection = null) {
    super(user, savedArticlesSection, readArticlesSection)
    this.savedArticlesSectionRef = savedArticlesSection
    this.readArticlesSectionRef = readArticlesSection
  }

  setArticlesSection(savedArticlesSection, readArticlesSection) {
    this.savedArticlesSectionRef = savedArticlesSection
    this.readArticlesSectionRef = readArticlesSection
    this.uiRenderer = new EvolokUIRenderer(
      savedArticlesSection,
      readArticlesSection
    )
  }

  get savedArticlesSection() {
    return this.uiRenderer?.savedArticlesSection
  }

  set savedArticlesSection(savedArticlesSection) {
    this.setArticlesSection(savedArticlesSection, this.readArticlesSectionRef)
  }

  get readArticlesSection() {
    return this.uiRenderer?.readArticlesSection
  }

  set readArticlesSection(readArticlesSection) {
    // Passo il valore esistente di savedArticlesSection per non perderlo
    this.setArticlesSection(this.savedArticlesSectionRef, readArticlesSection)
  }
}
